import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React__default, { useRef, useState } from 'react';
import { usePopper } from '../../../node_modules/react-popper/lib/esm/usePopper.js';
import styled from 'styled-components';
import { useResponsiveValue } from '../../hooks/use-match-media.js';
import { useOnClickOutside } from '../../hooks/use-on-click-outside.js';
import { useOnKeydownTrigger } from '../../hooks/use-on-keydown-trigger.js';
import { Box } from '../box/Box.js';
import { Card } from '../card/Card.js';
import { Drawer } from '../drawer/Drawer.js';

var sizeWidthMap = {
  sm: ["160px"],
  md: ["256px"],
  lg: ["360px"],
  fit: ["auto"]
};
var PopoverContent = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Popover__PopoverContent",
  componentId: "sc-cosgug-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  opacity: ", ";\n  pointer-events: ", ";\n  transition: opacity 0.1s linear;\n"], ["\n  opacity: ", ";\n  pointer-events: ", ";\n  transition: opacity 0.1s linear;\n"])), function (_a) {
  var open = _a.open;
  return open ? 1 : 0;
}, function (_a) {
  var open = _a.open;
  return open ? "auto" : "none";
});
var Popover = function (_a) {
  var _b = _a.placement,
    placement = _b === void 0 ? "bottom" : _b,
    _c = _a.size,
    size = _c === void 0 ? "md" : _c,
    controlledOpen = _a.isOpen,
    trigger = _a.trigger,
    children = _a.children,
    _d = _a.asDraw,
    asDraw = _d === void 0 ? [true, false, false] : _d,
    _e = _a.onCloseRequested,
    onCloseRequested = _e === void 0 ? function () {
      return console.error("onCloseRequested was called without being defined");
    } : _e,
    _f = _a.onToggleRequested,
    onToggleRequested = _f === void 0 ? function () {
      return console.error("onToggleRequested was called without being defined");
    } : _f,
    rest = __rest(_a, ["placement", "size", "isOpen", "trigger", "children", "asDraw", "onCloseRequested", "onToggleRequested"]);
  var wrapperRef = useRef(null);
  var triggerRef = useRef(null);
  var _g = useState(),
    popperRef = _g[0],
    setPopperRef = _g[1];
  var isControlled = typeof controlledOpen === "boolean";
  var isControlledOpen = isControlled && controlledOpen;
  var _h = useState(controlledOpen),
    isOpen = _h[0],
    setIsOpen = _h[1];
  var open = isControlled ? isControlledOpen : isOpen;
  var _j = usePopper(triggerRef.current, popperRef, {
      placement: placement,
      modifiers: [{
        name: "offset",
        options: {
          offset: [0, 10]
        }
      }]
    }),
    styles = _j.styles,
    attributes = _j.attributes,
    update = _j.update;
  var updatePopper = function () {
    typeof update === "function" && update();
  };
  var togglePopover = function () {
    if (!isControlled) {
      setIsOpen(function (prevIsOpen) {
        return !prevIsOpen;
      });
    } else {
      onToggleRequested();
    }
    updatePopper();
  };
  var closePopover = function () {
    if (!open) return;
    if (!isControlled) {
      setIsOpen(false);
    } else {
      onCloseRequested();
    }
    updatePopper();
  };
  useOnKeydownTrigger("Escape", closePopover);
  useOnClickOutside(wrapperRef, closePopover);
  var sizeString = useResponsiveValue(size);
  if (useResponsiveValue(asDraw)) {
    return React__default.createElement(Box, {
      ref: wrapperRef
    }, React__default.createElement(Box, {
      ref: triggerRef
    }, typeof trigger === "function" && trigger({
      onClick: function () {
        return togglePopover();
      }
    })), React__default.createElement(Drawer, __assign({
      size: sizeString,
      from: "bottom"
    }, rest, {
      onClose: closePopover,
      isOpen: !!open
    }), children));
  }
  return React__default.createElement(Box, {
    ref: wrapperRef
  }, React__default.createElement(Box, {
    ref: triggerRef
  }, typeof trigger === "function" && trigger({
    onClick: function () {
      return togglePopover();
    }
  })), React__default.createElement(PopoverContent, __assign({
    open: open,
    ref: setPopperRef,
    style: styles.popper
  }, attributes.popper, {
    width: sizeWidthMap[sizeString],
    maxWidth: sizeString === "fit" ? "100%" : sizeWidthMap[sizeString],
    zIndex: 999
  }, rest), React__default.createElement(Card, {
    backgroundColor: "white"
  }, children)));
};
var templateObject_1;

export { Popover };
//# sourceMappingURL=Popover.js.map
